import { computed } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1dfcc7d0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "batch-disable-tip"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'ThirdPartyBatchDisableModal',
  props: {
    open: {
      type: Boolean
    },
    payChnl: null,
    prodChnl: null,
    count: null,
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["confirm", "cancel"],
  setup(__props) {
    const props = __props;
    const channelName = computed(() => props.payChnl === 'xsolla_pay' ? 'Xsolla' : 'Enjoy');
    // 谷歌渠道多一份俄罗斯本地价格配置，iOS 沿用原文案
    const keepTip = computed(() => props.prodChnl === 'google' ? '默认价格、折扣、折扣描述及俄罗斯本地价格等原有配置会保留。' : '价格、折扣及折扣描述等原有配置会保留。');
    return (_ctx, _cache) => {
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.open,
        title: `批量关闭 ${_unref(channelName)} 支付`,
        width: 440,
        "confirm-loading": __props.submitLoading,
        "ok-text": `确认关闭（${__props.count}）`,
        "cancel-text": "取消",
        "ok-button-props": {
          disabled: !__props.count
        },
        onOk: _cache[0] || (_cache[0] = $event => _ctx.$emit('confirm')),
        onCancel: _cache[1] || (_cache[1] = $event => _ctx.$emit('cancel'))
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, "将关闭已选商品的 " + _toDisplayString(_unref(channelName)) + " 支付开关。" + _toDisplayString(_unref(keepTip)), 1)]),
        _: 1
      }, 8, ["open", "title", "confirm-loading", "ok-text", "ok-button-props"]);
    };
  }
});